<template>
  <div
    class="mx-auto !max-w-[1657px] py-12 lg:px-4 lg:py-24"
    :class="{ 'pt-0': data?.options?.NoTopSpaceMobile }"
  >
    <div class="flex flex-col lg:flex-row">
      <div class="shrink lg:pr-12">
        <div
          class="px-4 lg:block lg:max-w-[430px] lg:px-0 2xl:max-w-[630px]"
          :class="{
            hidden: data?.options?.hideIntroMobile,
          }"
        >
          <SubTitle class="text-blue">{{ data?.subtitle }}</SubTitle>
          <Title custom-style="leading-none">
            {{ data?.title }}
          </Title>
          <div
            class="mb-10 mt-3.5 font-sans text-base leading-snug text-black lg:text-base lg:leading-normal"
            v-html="data?.copy"
          ></div>
        </div>
        <div class="my-5 lg:hidden" :class="{ '!my-0': data?.options?.NoTopSpaceMobile }">
          <component
            :is="data?.video?.url ? VideoIframe : VideoPlayer"
            v-if="data?.mediaType === 'video' && (data?.video?.url || data?.video?.file)"
            :url="data.video.url || data?.video?.file"
            class="aspect-video w-full self-start"
          />
          <Image
            v-else-if="data?.image?.type === 'image' && data?.image?.url"
            :alt="data?.image?.alt"
            :url="data?.image?.url"
            class="aspect-video w-full self-start"
            width="600"
            height="300"
            sizes="xs:100vw sm:400"
            fit="cover"
          />
          <!-- Keep old support for videos in image field START -->
          <VideoIframe
            v-else-if="data?.image?.type === 'video' && data?.image?.url"
            :url="data?.image?.url"
            class="aspect-video w-full self-start"
          />
          <!-- Keep old support for videos in image field END -->
        </div>
        <Tabs :tabs="data?.tabs">
          <template v-for="(_, index) in data?.tabs" :key="index" v-slot:[`tab-${index}`]>
            <slot :name="`tab-${index}`" />
          </template>
          <template #content></template>
        </Tabs>
        <slot name="after-content"></slot>
      </div>
      <div class="hidden w-full lg:mt-8 lg:flex">
        <component
          :is="data?.video?.url ? VideoIframe : VideoPlayer"
          v-if="data?.mediaType === 'video' && (data?.video?.url || data?.video?.file)"
          :url="data.video.url || data?.video?.file"
          class="aspect-video w-full self-start rounded-2xl"
        />
        <Image
          v-else-if="data?.image?.type === 'image' && data?.image?.url"
          :alt="data?.image?.alt"
          :url="data?.image?.url"
          class="aspect-video w-full self-start rounded-2xl"
          width="600"
          height="300"
          sizes="xs:100vw sm:400"
          fit="cover"
        />
        <!-- Keep old support for videos in image field START -->
        <VideoIframe
          v-else-if="data?.image?.type === 'video' && data?.image?.url"
          :url="data.image.url"
          class="aspect-video w-full self-start rounded-2xl"
        />
        <!-- Keep old support for videos in image field END -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IImageData } from '../../types'
import Image from '../atoms/Image.vue'
import SubTitle from '../atoms/SubTitle.vue'
import Title from '../atoms/Title.vue'
import VideoIframe from '../atoms/VideoIframe.vue'
import VideoPlayer from '../atoms/VideoPlayer.vue'
import Tabs, { type ITab } from '../molecules/Tabs.vue'

export interface ITabsBlock {
  id: string
  subtitle?: string
  title?: string
  mediaType: 'image' | 'video'
  image?: IImageData
  video?: {
    url?: string
    file?: string
  }
  copy?: string
  tabs?: ITab[]
  options?: {
    hideIntroMobile?: boolean
    NoTopSpaceMobile?: boolean
  }
}

interface Props {
  data: ITabsBlock
}

defineProps<Props>()
</script>
